export default __webpack_public_path__ + "static/media/pts.fbe6ea2c.png";